import { ClickEvent, DataDisplayEvent, Label, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { Alignment, ModelRow, Navigation } from "@mcleod/core";
import { DataFusionListUtil } from "./DataFusionListUtil";
import { AutogenLayoutInboundTenderList } from "./autogen/AutogenLayoutInboundTenderList";
import { CommonTooltips } from "@mcleod/common";

export class InboundTenderList extends AutogenLayoutInboundTenderList {
    private _searchTendersURL = "lme/datafusion/TenderList?id=";
    private _viewTenderURL = "lme/datafusion/ViewEdiOrder?mode=update&key=";

    setErrorsLabelColor(event) {
        DataFusionListUtil.setErrorsLabelColor(event, true);
    }

    setWarningsLabelColor(event) {
        DataFusionListUtil.setErrorsLabelColor(event, false);
    }

    buttonAdditionalInfoOnClick() {
        const orderId = this.mainDataSource.data[0]?.get("order_id") as string;
        Navigation.navigateTo(this.searchTendersURL + orderId, { newTab: true });
    }

    tableInboundTendersOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        tableRow.addDblClickListener((event: ClickEvent) => {
            const tableRow = event.target as TableRow;
            const modelRow = tableRow?.data as ModelRow;
            const tenderId = modelRow?.get("id");
            if (tenderId) Navigation.navigateTo(this.viewTenderURL + tenderId, { newTab: true });
        });
    }

    displayPartnerName(event: DataDisplayEvent) {
        const partnerNameLabel = <Label>event.target;
        const modelRow = this.mainDataSource.activeRow as ModelRow;
        CommonTooltips.setTooltipContentLayout(partnerNameLabel, null, "lme/datafusion/EdiProfileOrderQuickInfo", null,
            {
                "direction": modelRow.get("direction"),
                "partner_id": modelRow.get("partner_id"),
                "alt_partner_id": modelRow.get("alt_partner_id"),
                "version": modelRow.get("version"),
                "batch": modelRow.get("gs06_group_cntlno"),
                "trans_type": 'T',
                "create_date": modelRow.get("create_date")
            }
        );
        partnerNameLabel.tooltipDynamicOptions = { position: Alignment.BOTTOM };
    }

    get searchTendersURL() {
        return this._searchTendersURL;
    }

    get viewTenderURL() {
        return this._viewTenderURL;
    }
}
